import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { closePopup } from '../../actions/uiActions'
import { createCustomer } from '../../actions/userActions'
import CloseIcon from '@mui/icons-material/Close';
class AddCustomer extends React.Component {
    state = {
        name: ""
    }

    changeName = (event) => {
        this.setState({ name: event.target.value })
    }

    handleSubmit = (event) => {
        event.preventDefault()
        this.props.createCustomer(this.state.name)
    }

    handleClick = (event) => {
        event.preventDefault()
        this.props.closePopup()
    }

    disableSubmitButton = (customerName) => {
        if (customerName.trim().length === 0) {
            return true
        }
        return false
    }

    render() {
        return (
            <Dialog
                open={true}
                onClose={this.handleClick}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <CloseIcon onClick={this.handleClick} className="closePoup" />
                <DialogTitle id="alert-dialog-title" className="changepassdialog">
                    Add A New Customer
                </DialogTitle>
                <DialogContent>
                    <form className="form" onSubmit={this.handleSubmit}>
                        <div className="myInputOut">
                            <input
                                type="text"
                                className="myInput"
                                onChange={this.changeName}
                                value={this.state.name}
                                placeholder="Customer Name"
                                required
                            />
                        </div>
                        <button className="btn" type="submit" value="Submit" id="submit_btn" disabled={this.disableSubmitButton(this.state.name)}>Submit</button>
                    </form>
                </DialogContent>
            </Dialog>
        )
    }
}

function mapStateToProps(state) {
    return {
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup, createCustomer }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddCustomer)